import gql from "graphql-tag";

const COMMON_QUERY = `
id
name
createdAt
updatedAt
`;

const getAllHelpdeskCategoryGroup = gql`
  query(
    $limit: Int
    $page: Int
    $query: String
  ) {
    getAllHelpdeskCategoryGroup(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      ${COMMON_QUERY}
    }
  }
`;

export default { getAllHelpdeskCategoryGroup };
